import { createI18n } from 'vue-i18n';
import store from '@/store';

// 默认语言
const langDefault = store.getters.language;
let messages = null;

const getData = async () => {
  messages = await store.dispatch("getLang");

  for (const key in messages) {
    if (key == "en") {
      i18n.global.setLocaleMessage("en", {
        ...messages[key],
      });
    } else if (key == "zh") {
      i18n.global.setLocaleMessage("zh", {
        ...messages[key]
      });
    } else {
      i18n.global.setLocaleMessage(key, {
        ...messages[key]
      });
    }
  }
}

const i18n = createI18n({
  locale: langDefault,		//默认显示的语言 
  messages,
  silentTranslationWarn: true,
  globalInjection: true
})

getData();

export default i18n; // 将i18n暴露出去，在main.js中引入挂载